export enum VisibleToEnum {
  Me = 'Me',
  Everyone = 'Everyone',
}
